import { render, staticRenderFns } from "./Assignments.vue?vue&type=template&id=1f403c78&scoped=true&"
import script from "./Assignments.vue?vue&type=script&lang=js&"
export * from "./Assignments.vue?vue&type=script&lang=js&"
import style0 from "./Assignments.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Assignments.vue?vue&type=style&index=1&id=1f403c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f403c78",
  null
  
)

export default component.exports